<div class="page-wrap">
    <div class="selection-container" (click)="evaluateTrain()">
        <div class="selection-image-wrapper">
            <img class="img-train" src="../../../assets/train.png">
            <div class="overlay">
                <div class="centered">Train Evaluation</div>
            </div>
        </div>
    </div>
    <div class="selection-container" (click)="evaluateVariant()">
        <div class="selection-image-wrapper">
            <img class="img-variant" src="../../../assets/variant.png">
            <div class="overlay">
                <div class="centered">Layout Evaluation</div>
            </div>
        </div>
    </div>
</div>